"use client";

import { TableSkeletonBody } from "@/components/ui/table";

/** Skeleton rows shaped like the real meeting cells — copies jobs' `table/pending.tsx`. */
export function ConversationsSkeleton({
  count,
  compact,
}: {
  count: number;
  compact?: boolean;
}) {
  return (
    <TableSkeletonBody
      count={count}
      renderCells={() =>
        compact
          ? [
              <div key="title" className="flex min-w-0 w-full flex-col gap-1">
                <div className="h-4 w-[85%] max-w-56 rounded bg-contrast/6" />
                <div className="h-3 w-[60%] max-w-40 rounded bg-contrast/6" />
              </div>,
              <div key="state" className="h-5 w-[86px] rounded-md bg-contrast/6" />,
              <div key="when" className="h-4 w-[92px] rounded bg-contrast/6" />,
              <span key="actions" />,
            ]
          : [
              <div key="title" className="flex min-w-0 w-full flex-col gap-1">
                <div className="h-4 w-[85%] max-w-56 rounded bg-contrast/6" />
                <div className="h-3 w-[60%] max-w-40 rounded bg-contrast/6" />
              </div>,
              <div key="state" className="h-5 w-[86px] rounded-md bg-contrast/6" />,
              <div key="entity" className="flex min-w-0 items-center gap-1">
                <div className="size-3 shrink-0 rounded-[2px] bg-contrast/6" />
                <div className="h-5 w-[104px] rounded-sm bg-contrast/6" />
              </div>,
              <div key="participants" className="h-5 w-[96px] rounded-sm bg-contrast/6" />,
              <div key="when" className="h-4 w-[92px] rounded bg-contrast/6" />,
              <div key="attention" className="h-5 w-[78px] rounded-sm bg-contrast/6" />,
              <span key="actions" />,
            ]
      }
    />
  );
}
